import { type } from "os";

export interface Department {
  id: string;
  name: string;
  description: string; // Adding this field that's referenced in the component
}

// Create a schema representation of the interface
export const DepartmentSchema = {
  name: 'Department',
  nameAttribute: 'name',
  idType: 'string',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    description: { type: 'string' },
    company: { type: 'string' },
    short_code: { type: 'string' },
    vertical_id: { type: 'string' },
    vertical: {
      type: 'object',
      properties: {
        id: { type: 'string' },
        name: { type: 'string' },
        company: {
          type: 'object',
          properties: {
            id: { type: 'string' },
            name: { type: 'string' }
          }
        }
      }
    }
  }
};
